import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/assistant.runtime';

/** Assistant visibility source; currently selected at build time by the portal environment. */
@Injectable({ providedIn: 'root' })
export class AssistantRuntimeConfigService {
  private readonly enabledState = signal(environment.assistantEnabled === true);
  readonly enabled = this.enabledState.asReadonly();
}
